export class News {
    user: string;
    date: string;
    value: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
